import { useGetEntityTemplate } from "@/entities/entity-template";
import { AssetTypeTemplateFormEditor } from "@/modules/asset-type-template/asset-type-template-form-editor";
import { AssetTypeTemplatePageHeader } from "@/modules/asset-type-template/asset-type-template-page-header";
import { PageItemGate } from "@/modules/page-item-gate";
import { useIdParam } from "@/services/router";

export const AssetTypeTemplatePage = () => {
  const id = useIdParam();

  const { isLoading, template, error } = useGetEntityTemplate(id);

  return (
    <PageItemGate model="technicalform" queryError={error}>
      <AssetTypeTemplatePageHeader template={template} loading={isLoading} />
      <AssetTypeTemplateFormEditor template={template} loading={isLoading} />
    </PageItemGate>
  );
};
